import { call, put, takeEvery, delay } from 'redux-saga/effects';
import { init as initApm } from '@elastic/apm-rum';
import { NON_WORKFLOW_PAGES } from 'config/workflow';
import sessionActions from './actions';
import pageActions from '../page/actions';
import workFlowActions from '../workflow/actions';
import homeActions from '../home/actions';
import themeActions from '../theme/actions';

function* initSession() {
  yield put(sessionActions.getSession(true));
}

function* getSession({ payload }) {
  try {
    const response = yield call(payload.request);
    const { data } = response;
    const requestedPageName = window.location.pathname.split('/')?.slice(-1)?.[0]?.toLowerCase();

    yield put(sessionActions.getSuccess(data));

    if (payload.init) {
      if (NON_WORKFLOW_PAGES.includes(requestedPageName)) {
        if (requestedPageName === 'home') {
          yield put({ payload: { data }, type: homeActions.START });
        } else {
          yield put(pageActions.goToNonWorkflowPage(requestedPageName));
        }
      } else {
        yield put({ payload: { data }, type: workFlowActions.START });
      }
    }
  } catch (e) {
    const {
      response: { data, status },
    } = e;
    if (!data.result) {
      yield put(sessionActions.getFailed(data));
    } else {
      yield put(pageActions.goToPageError(data, status));
    }
  }
}

function* initExternalLibraries({ payload }) {
  try {
    const {
      data: {
        meta: {
          configs: { apm, jsc_enabled: jscEnabled },
        },
      },
    } = payload;

    const { labels, ...restConfigs } = apm;

    if (apm && apm.active) {
      yield initApm({
        // Config should set these at a minimum
        active: false,
        environment: '',
        serverUrl: '',
        serviceName: '',
        serviceVersion: window.version,
        ...restConfigs,
      });
      yield window.elasticApm?.addLabels(labels);
    }

    if (jscEnabled) {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'deviceToken');
      input.setAttribute('id', 'deviceToken');
      document.querySelector('body').appendChild(input);
      window.fnglobal.init(null);

      const url = `${window.location.protocol}//${window.location.host}/fnrd/resource.png`;
      window.fnglobal.setResource(url, true, () => window.fnglobal.fnform('deviceToken'));
      yield delay(500);
      const deviceToken = document.querySelector('#deviceToken').value;
      input.remove();
      yield put(sessionActions.jscSuccess(deviceToken));
    }
  } catch (e) {
    // Do nothing
  }
}

export default [
  takeEvery([themeActions.GET_SUCCESS, themeActions.GET_LEGACY_SUCCESS], initSession),
  takeEvery(sessionActions.GET, getSession),
  takeEvery(sessionActions.GET_SUCCESS, initExternalLibraries),
];
